import { configureStore } from "@reduxjs/toolkit";
import { useSelector, TypedUseSelectorHook, useDispatch } from "react-redux";

import shipmentsReducer from "./features/shipment-slice";
import shipmentFiltersReducer from "./features/shipment-filter-slice";
import sidebarReducer from "./features/sidebar-slice";
import userReducer from "./features/user-slice";

export const store = configureStore({
  reducer: {
    user: userReducer,
    shipments: shipmentsReducer,
    shipmentFilters: shipmentFiltersReducer,
    sidebar: sidebarReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Increase the threshold to 50ms
        warnAfter: 50,
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<typeof store.dispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
